import { Heading3 } from "@/components/text/Heading3";

export function BlogHeading3({ children }: { children: React.ReactNode }) {
  return (
    <Heading3 elementType="h3" className="mb-4">
      {children}
    </Heading3>
  );
}
